import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Additional helper hooks
export const useCurrentUser = () => {
  const { user } = useAuth();
  return user;
};

export const useCurrentUserId = () => {
  const { user } = useAuth();
  return user?.userId || null;
};

export const useCurrentDriverId = () => {
  const { user } = useAuth();
  return user?.driverId || -1;
};

export const useCurrentVehicleId = () => {
  const { user } = useAuth();
  return user?.vehicleId || -1;
};

export const useIsAdmin = () => {
  const { user } = useAuth();
  return user?.roles?.includes('ADMIN') || false;
};

export const useHasDriverProfile = () => {
  const { user } = useAuth();
  return user?.driverId && user.driverId !== -1;
};

export const useHasVehicleProfile = () => {
  const { user } = useAuth();
  return user?.vehicleId && user.vehicleId !== -1;
};